var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element/Misc/Circle Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-9---Search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6--User-result---edit",
    transform: "translate(-181.000000, -670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-info",
    transform: "translate(149.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeline",
    transform: "translate(32.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Misc/Circle-Icon",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Base",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.2,
    mask: "url(#mask-2)",
    fill: "#EBA601"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element/Icon/Message",
    mask: "url(#mask-2)",
    fill: "#EBA601"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 10.000000)",
    id: "\\uD83C\\uDFA8-Icon-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85359469,10.743002 C3.27469322,11.6728646 4.33508808,11.6254312 4.67337999,10.6575744 L6.2842934,6.04873351 L8.00506198,11.2108715 C8.35805001,12.2698012 9.51108619,12.1829376 9.69578673,11.0747344 L11.116487,2.55053266 L12.6737727,5.66510404 C12.8466619,6.01088245 13.2671251,6.15103683 13.6129035,5.97814763 C13.9586819,5.80525842 14.0988363,5.38479525 13.9259471,5.03901684 L11.7200533,0.627229389 C11.2465033,-0.31987058 10.1496062,-0.163889248 9.97406419,0.889363044 L8.66278915,8.7570134 L7.18487368,4.32341106 C6.84907945,3.31606108 5.75307901,3.3255883 5.40665235,4.31671875 L3.69626594,9.21015297 L3.0265171,7.73122493 C2.63638169,6.86973455 1.62733158,6.80536701 1.14347327,7.62783887 L0.0967721883,9.40704197 C-0.0992531901,9.74024976 0.0119551309,10.169278 0.345162925,10.3653034 C0.67837072,10.5613288 1.10739897,10.4501205 1.30342435,10.1169127 L2.01912767,8.90034607 L2.85359469,10.743002 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.e097d409ae871ef153231bedd7dd9a06.svg";
export { ForwardRef as ReactComponent };